import axios from './_contaAxios'

export const getPendientesxSocioxOrigen = (idSocio, origen) =>
  axios.get('/asientos-contables/pendientes', {
    params: { idSocio: idSocio, origen: origen, reqSource: 'INV' }
  })

export const nuevoAsientoContableCobranza = data =>
  axios.post('/asientos-contables/4', data, {
    params: {
      reqSource: 'INV'
    }
  })

export const descargarPdfTicketCobranzas = _id =>
  axios.get(`/asientos-contables/descargar/${_id}/cobranzas`, { responseType: 'blob', params: { reqSource: 'INV' } })

export const descargarReporteCobranzasxFechaxUsuario = data =>
  axios.get('/asientos-contables/descargar/reporteCobranzas', { responseType: 'blob', params: data })

export const descargarPdfCajaxTurno = idTurno =>
  axios.get('/asientos-contables/descargar/reporte-caja-x-turno', { responseType: 'blob', params: { idTurno } })
